const STORAGE_PREFIX = 'intelligence_opinion_event_setting:';

export interface IPersistedOpinionChartEventSetting {
  showEventAxis: boolean;
  showEventBubbles: boolean;
  selectedEventKeys: Record<string, string[]>;
  isCustomized: boolean;
}

export function buildOpinionEventSettingStorageKey(
  page: 'kpi-trends' | 'stats',
  gameId: string,
  pageId?: string,
): string {
  if (page === 'stats' && pageId) {
    return `stats:${pageId}:${gameId}`;
  }

  return `kpi-trends:${gameId}`;
}

export function loadOpinionChartEventSetting(
  storageKey?: string,
): IPersistedOpinionChartEventSetting | null {
  if (!storageKey) {
    return null;
  }

  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${storageKey}`);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as IPersistedOpinionChartEventSetting;
    if (!parsed?.isCustomized) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
}

export function saveOpinionChartEventSetting(
  storageKey: string,
  setting: IPersistedOpinionChartEventSetting,
): void {
  try {
    sessionStorage.setItem(
      `${STORAGE_PREFIX}${storageKey}`,
      JSON.stringify(setting),
    );
  } catch {
    // ignore quota errors
  }
}
